/* The basis switch: two pills in one bordered group, the same height as the buttons beside it
   (`--target-min` floor). The chosen one is filled with the accent and says so by its fill, its weight
   and the radio's checked state - never colour alone. */
.group {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  overflow: hidden;
}

.choice {
  display: inline-flex;
  position: relative;
  cursor: pointer;
}

/* Visually hidden but focusable: the face below shows the state and the ring. */
.input {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.face {
  display: inline-flex;
  align-items: center;
  min-height: var(--target-min);
  padding: 4px 12px;
  color: var(--ink-2);
  font-size: var(--t-min);
  font-weight: 500;
  white-space: nowrap;
}

.input:checked + .face {
  background: var(--accent);
  color: var(--on-fill);
  font-weight: 650;
}

.input:focus-visible + .face {
  outline: 2px solid var(--focus);
  outline-offset: -2px;
}

.choice:hover .face {
  background: var(--accent-w);
}

.input:checked + .face,
.choice:hover .input:checked + .face {
  background: var(--accent);
}
